import { NgxMaskConfig } from 'ngx-mask';

export const specialCharactersNotAllowed: NgxMaskConfig['patterns'] = {
  A: { pattern: new RegExp('[^:\'";()&<>*^\x00|]') },
};

export function sanitizeString(str: string): string {
  return str.replace(/[:\'";()&<>*^\x00|]/g, '');
}
